module.exports = __webpack_public_path__ + "static/media/kira-rodriguez.0a539322.md";